// 把gallery实例暴露到了window
/* eslint-disable */
import previewComponent from './preview.vue'
import PhotoSwipe from 'photoswipe/dist/photoswipe'
import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
import { isPC } from '../../utils/utils'
let $preview
var timeOutEvent = 0;
var timer;
var vuePhotoPreview = {
	install(Vue, opts) {
		let Preview = Vue.extend(previewComponent)
		var opts = opts || {}
		if (!$preview) {
			$preview = new Preview({
				el: document.createElement('div')
			})
			document.body.appendChild($preview.$el)
		}
		Vue.mixin({
			data () {
				return {
					galleryElements: null
				}
			},
			methods: {
				$previewClose () {
          window.gallery.close()
				},
				$previewRefresh() {
					setTimeout(() => {
						this.galleryElements = document.querySelectorAll('img[preview]')
						for (var i = 0, l = this.galleryElements.length; i < l; i++) {
							this.galleryElements[i].setAttribute('data-pswp-uid', i + 1)
							this.galleryElements[i].onclick = this.onThumbnailsClick
						}
					}, 200)
				},
				onThumbnailsClick(e) {
					// 预览图片时，不能点击分享，为防止点击关闭时触发分享操作
					this.$store.commit('SET_THUMBNAIL_FULL_FLAG', true)

					e = e || window.event
					e.preventDefault ? e.preventDefault() : e.returnValue = false

					var eTarget = e.target || e.srcElement

					var thumbElements
					var group = eTarget.getAttribute('preview')
					if (group) {
						thumbElements = document.querySelectorAll('img[preview="' + group + '"]')
					} else {
						thumbElements = document.querySelectorAll('img[preview]')
					}
					var clickedGallery = thumbElements

					var index

					for (var i = 0; i < clickedGallery.length; i++) {
						if (clickedGallery[i] === eTarget) {
							index = i
							break
						}
					}
					if (index >= 0) {
						this.openPhotoSwipe(index, clickedGallery)
					}
					return false
				},
				openPhotoSwipe(index, galleryElement, disableAnimation, fromURL) {
					var pswpElement = document.querySelectorAll('.pswp')[0],
						gallery,
						options,
						items

					var items = this.parseThumbnailElements(galleryElement)
					options = {

						//galleryUID: galleryElement.getAttribute('data-pswp-uid'),
						fullScreenEl: false,
						tapToClose: false,


						getThumbBoundsFn: function () {
							var thumbnail = items[index].el,
								pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
								rect = thumbnail.getBoundingClientRect()

							return {
								x: rect.left,
								y: rect.top + pageYScroll,
								w: rect.width
							}
						},

						addCaptionHTMLFn: function (item, captionEl, isFake) {
							if (!item.title) {
								captionEl.children[0].innerText = ''
								return false
							}
							captionEl.children[0].innerHTML = item.title
							return true
						},
						showHideOpacity: true,
						history: false,
						shareEl: false,


					}

					if (fromURL) {
						if (options.galleryPIDs) {
							// parse real index when custom PIDs are used
							// http://photoswipe.com/documentation/faq.html#custom-pid-in-url
							for (var j = 0; j < items.length; j++) {
								if (items[j].pid == index) {
									options.index = j
									break
								}
							}
						} else {
							options.index = parseInt(index, 10) - 1
						}
					} else {
						options.index = parseInt(index, 10)
					}

					// exit if index not found
					if (isNaN(options.index)) {
						return
					}
					options = this.extend(options, opts)


					if (disableAnimation) {
						options.showAnimationDuration = 0
					}

					// Pass data to PhotoSwipe and initialize it
					window.gallery = gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)

					// see: http://photoswipe.com/documentation/responsive-images.html
					var realViewportWidth,
						useLargeImages = false,
						firstResize = true,
						imageSrcWillChange

					gallery.listen('beforeResize', function () {

						var dpiRatio = window.devicePixelRatio ? window.devicePixelRatio : 1
						dpiRatio = Math.min(dpiRatio, 2.5)
						realViewportWidth = gallery.viewportSize.x * dpiRatio

						if (realViewportWidth >= 1200 || (!gallery.likelyTouchDevice && realViewportWidth > 800) || screen.width > 1200) {
							if (!useLargeImages) {
								useLargeImages = true
								imageSrcWillChange = true
							}

						} else {
							if (useLargeImages) {
								useLargeImages = false
								imageSrcWillChange = true
							}
						}

						if (imageSrcWillChange && !firstResize) {
							gallery.invalidateCurrItems()
						}

						if (firstResize) {
							firstResize = false
						}

						imageSrcWillChange = false

					})

					gallery.listen('gettingData', function (index, item) {
						if (useLargeImages) {
							item.src = item.o.src.indexOf('?x-oss-image') > -1 ? item.o.src.split('?')[0] : item.o.src
							item.w = item.o.w
							item.h = item.o.h
						} else {
							item.src = item.m.src.indexOf('?x-oss-image') > -1 ? item.m.src.split('?')[0] : item.m.src
							item.w = item.m.w
							item.h = item.m.h
						}
					})


					let self = this;

					gallery.listen('close',function(){
						console.log('close啊', self.$store.state.thumbnailFullFlag)
						setTimeout(() => {
							// 关闭预览时，搜索可以触发
							self.$store.commit('SET_THUMBNAIL_FULL_FLAG', false);
					  }, 100);
						gallery=null
						window.gallery=null
						if (window.location.hash.split('?')[0] === '#/articlePreview' ||
						  window.location.hash.split('?')[0] === '#/content/preview') {
							document.getElementsByClassName('article-preview')[0].style = ''
						} else {
							document.getElementsByClassName('article-detail')[0].style = ''
						}
						setTimeout(() => {
							if (document.documentElement && document.documentElement.scrollTop) {
								document.documentElement.scrollTop = self.scrollTop
							} else {
								document.body.scrollTop = self.scrollTop
							}
							window.scrollTo(0, self.scrollTop)
						}, 100)
						// setTimeout(() => {
							// 关闭预览时，搜索可以触发
						//	self.$store.commit('SET_THUMBNAIL_FULL_FLAG', false);
						// }, 1000);
					})
					// 图片翻转的问题，开始
					// Opening zoom in animation finished
					gallery.listen('initialZoomInEnd', function() {
						console.log('initialZoomInEnd')
						// checkImgDir()
						if (window.location.hash.split('?')[0] === '#/articlePreview' ||
						window.location.hash.split('?')[0] === '#/content/preview') {
							document.getElementsByClassName('article-preview')[0].style.display = 'none'
						} else {
							document.getElementsByClassName('article-detail')[0].style.display = 'none'
						}
						// 鉴别长按事件与单击事件
						$(function(){
							$(document).on({
								touchstart: function (e) {
									console.log('e', e)
									timeOutEvent = setTimeout(() => {
										timeOutEvent = 0;
										// 长按事件触发
										timer = setInterval(() => {
											console.log(1)
										}, 500);
									}, 500)
									e.preventDefault();
								},
								touchmove: function () {
									console.log('清除定时器 move', timeOutEvent)
									clearTimeout(timeOutEvent);
									timeOutEvent = 0;
								},
								touchend: function () {
									console.log('清除定时器 end', timeOutEvent)
									clearTimeout(timeOutEvent);
									clearInterval(timer)
									if (timeOutEvent != 0) {
										self.$store.commit('SET_CLOSE_GALLERY', true)
										// 点击关闭事件触发
									}
									return false
								}
							}, '.pswp__container', '.pswp__img')
						});
						// document.getElementsByClassName('pswp__scroll-wrap')[0].ontouchend = function () {
						//   items[gallery.getCurrentIndex()].w = items[gallery.getCurrentIndex()].o.w
						//   items[gallery.getCurrentIndex()].h = items[gallery.getCurrentIndex()].o.h
						// }
					});
					gallery.listen('afterChange', function() {
						// 预览帖子图片时，不能点击搜索，为防止点击关闭时触发搜索操作
						self.$store.commit('SET_THUMBNAIL_FULL_FLAG', true)
						console.log('afterChange')
						// checkImgDir()
					});
					// 图片翻转的问题，结束
					gallery.init()
				},
				parseThumbnailElements(thumbElements) {
					var items = [],
						el,
						load = 0,
						item
					for (var i = 0; i < thumbElements.length; i++) {
						el = thumbElements[i]
						// include only element nodes
						if (el.nodeType !== 1) {
							continue
						}


						if (typeof el.naturalWidth == 'undefined') {　　 // IE 6/7/8

							var i = new Image()
							i.src = el.src.indexOf('?x-oss-image') > -1 ? el.src.split('?')[0] : el.src
							var rw = i.width
							var rh = i.height
						} else {　　 // HTML5 browsers
                            
							var rw = el.naturalWidth
							var rh = el.naturalHeight
							var dataRatio = $(el).attr('data-ratio')
							var dataW = rw
							var dataH = rh

							// 懒加载导致图片还没有加载上，宽高被初始化为1
							if( dataW == 1 || dataH == 1 ){
								var originWidth = el.dataset.w;
								var originHeight = el.dataset.h;
								rw = originWidth;
								rh = originHeight;
							}
							let clientWidth = document.documentElement.clientWidth || document.body.clientWidth
							if (isPC() && dataRatio) {
							  dataW = clientWidth
							  dataH = clientWidth * dataRatio
							}
							// var dataH = $(el).attr('data-h')
						}
						// 图片src应该从dataset取，懒加载未初始化的时候 src是一个base64的东西会导致src不正确
						var dataSetIsValid = el.dataset.src && !el.dataset.src.match(/^data/)
						var src = dataSetIsValid ? el.dataset.src : el.getAttribute('src');
						item = {
							title: el.getAttribute('preview-text'),
							el: el,
							src: src.indexOf('?x-oss-image') ? src.split('?')[0] : src,
							w: rw,
							h: rh,
							author: el.getAttribute('data-author'),
							o: {
								src: src,
								w: dataW || rw,
								h: dataH || rh,
							},
							m: {
								src: src,
								w: dataW || rw,
								h: dataH || rh,
							}
						}
						// console.log(item)
						items.push(item)
					}
					return items

				},
				extend(o1, o2) {
					for (var prop in o2) {
						o1[prop] = o2[prop]
					}
					return o1
				},
				init(gallerySelector) {
					this.galleryElements = document.querySelectorAll(gallerySelector)
					for (var i = 0, l = this.galleryElements.length; i < l; i++) {
						this.galleryElements[i].setAttribute('data-pswp-uid', i + 1)
						this.galleryElements[i].onclick = this.onThumbnailsClick
					}
				}
			},
			mounted: function () {
				this.init('img[preview]')
			}
		})
	}
}

export default vuePhotoPreview

if (typeof window !== 'undefined' && !window.vuePhotoPreview) {
	window.vuePhotoPreview = vuePhotoPreview
}

/* eslint-disable */